import React, { useState } from "react";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";
import logo from "../assets/img/logoadutem.png";

const SIN_ERROR = { field: "", message: "" };

const Login = () => {
  const [correo, setCorreo] = useState("");
  const [clave, setClave] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(SIN_ERROR);
  const [mostrarClave, setMostrarClave] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(SIN_ERROR);

    if (!correo || !clave) {
      setError({ field: "", message: "Ingrese correo y contraseña" });
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post("/login", {
        email: correo.trim().toLowerCase(),
        password: clave,
      });

      // 🔐 Guardar sesión
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("usuario", JSON.stringify(res.data.usuario));

      // 👉 Redirección según rol
      if (res.data.usuario.rol === "SECRETARIA") {
        navigate("/DashboardSecretaria");
      } else if (res.data.usuario.rol === "SOCIO") {
        navigate("/DashboardSocio");
      } else {
        setError({ field: "", message: "Rol no reconocido" });
      }
    } catch (err) {
      if (err.response) {
        setError({
          field: err.response.data?.field || "",
          message: err.response.data?.message || "No se pudo iniciar sesión",
        });
      } else {
        setError({ field: "", message: "Error de conexión con el servidor" });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vh-100 d-flex justify-content-center align-items-center bg-light">
      <div className="card shadow-lg p-4" style={{ maxWidth: "400px", width: "100%" }}>
        <div className="text-center mb-4">
          <img
            src={logo}
            alt="ADUTEM"
            className="img-fluid"
            style={{ width: "100%", maxWidth: "200px" }}
          />
          <h3 className="mt-3 text-success">Ingreso Socios ADUTEM</h3>
        </div>

        <form onSubmit={handleLogin}>
          {/* Correo */}
          <div className="mb-3">
            <label className="form-label">Correo electrónico</label>
            <input
              type="email"
              className={`form-control ${error.field === "email" ? "is-invalid" : ""}`}
              placeholder="Ingrese su correo"
              value={correo}
              onChange={(e) => {
                setCorreo(e.target.value);
                setError(SIN_ERROR);
              }}
              required
            />
            {error.field === "email" && (
              <div className="invalid-feedback">{error.message}</div>
            )}
          </div>

          {/* Contraseña */}
          <div className="mb-4">
            <label className="form-label">Contraseña</label>
            <div className="input-group has-validation">
              <input
                type={mostrarClave ? "text" : "password"}
                className={`form-control ${error.field === "password" ? "is-invalid" : ""}`}
                placeholder="Ingrese su contraseña"
                value={clave}
                onChange={(e) => {
                  setClave(e.target.value);
                  setError(SIN_ERROR);
                }}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setMostrarClave(!mostrarClave)}
              >
                <i className={`bi ${mostrarClave ? "bi-eye-slash" : "bi-eye"}`}></i>
              </button>
              {error.field === "password" && (
                <div className="invalid-feedback">{error.message}</div>
              )}
            </div>
          </div>

          <button type="submit" className="btn btn-success w-100" disabled={loading}>
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>

        {/* Error general (conexión, rol, campos vacíos) */}
        {error.message && !error.field && (
          <div className="alert alert-danger mt-3">{error.message}</div>
        )}

        <div className="d-flex justify-content-between mt-3">
          <small>
            <a href="/recuperarclave" className="text-decoration-none text-success">
              Recuperar clave
            </a>
          </small>
          <small>
            <a href="/registro" className="text-decoration-none text-success">
              Crear cuenta
            </a>
          </small>
        </div>
      </div>
    </div>
  );
};

export default Login;